/* Function to add partner details */
function addPartnerBlock(response) {
    const firstName = response.FirstName;
    const lastName = response.LastName;
    if (response.hide_partner_info !== "Yes") {
        document.querySelectorAll('.partner-container').forEach(elm => elm.classList.remove("display-none"));
        document.querySelectorAll('.partner-info-container').forEach(elm => elm.innerHTML = firstName + ' ' + lastName);
    }
}

function removePartnerBlock() {
    document.querySelectorAll('.partner-container').forEach(elm => elm.classList.add("display-none"));
    document.querySelectorAll('.partner-info-container').forEach(elm => elm.innerHTML = '');
}

/* Cookie management functions */
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function deleteCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
}

/* Function to fetch parter api response and store in localStorage and cookie */
async function fetchPartnerInfo(url, type, id, retryCount) {
    let updatedURL = url + "&" + type + "=" + id
    console.log('fetchPartnerInfo: called with url:', url, 'type:', type, 'id:', id, 'retryCount:', retryCount);
    console.log('fetchPartnerInfo: about to fetch', updatedURL);
    if (retryCount === 0) return null;
    try {
        const response = await fetch(updatedURL)
        if (!response.ok) {
            console.log(`Fetch failed, retrying... (${retryCount - 1} retries left)`);
            return await fetchPartnerInfo(url, type, id, retryCount - 1);
        } else if (response.status === 204) {
            console.log('No content returned from API (204)');
            return null;
        }
        const responseBody = await response.json();
        console.log('fetchPartnerInfo: responseBody:', responseBody);
        if (responseBody.error) {
            console.log('Error in response body:', responseBody.error);
            return null;
        }
        const partnerInfoString = JSON.stringify(responseBody);
        localStorage.setItem('partnerInfo', partnerInfoString);
        setCookie('partnerID', responseBody.commSysPartnerID, 90); 
        sessionStorage.setItem('lastPartner', responseBody.commSysPartnerID);
        return responseBody;
    } catch (error) {
        console.log('Failed to process partner information' + error);
        return await fetchPartnerInfo(url, type, id, retryCount - 1);
    }
}

/* Get partner information from local storage or cookie */
function getPartnerDetailsFromLocalStorage() {
    let partnerLocalDetails = localStorage.getItem('partnerInfo');
    if (!partnerLocalDetails) {
        // If not in localStorage, try to get from cookie (now just the ID)
        const partnerID = getCookie('partnerID');
        if (partnerID) {
            // If we have the ID, we could optionally fetch the full info here if needed
            // For now, just return an object with the ID
            return { commSysPartnerID: partnerID };
        }
    }
    
    if (partnerLocalDetails && partnerLocalDetails !== null) {
        try {
            console.log('Retrieved partner info from storage:', partnerLocalDetails);
            const parsedInfo = JSON.parse(partnerLocalDetails);
            // If we got it from cookie, also update localStorage (not needed for just ID)
            return parsedInfo;
        } catch (error) {
            console.log('Failed to parse partner storage data' + error);
        }
    } else {
        document.querySelectorAll('.partner-container').forEach(function(element) {
            element.classList.add("display-none");
        });
    }
    return null;
}

function getUrlParams() {
    let urlParams = new URLSearchParams(window.location.search);
    const isFromCheckout = urlParams.has('checkout_url');
    console.log("isFromCheckout:", isFromCheckout);
    if (isFromCheckout) {
        const checkoutUrlEncoded = getCheckoutUrl();
        const urlDecoded = decodeURIComponent(checkoutUrlEncoded);
        urlParams = new URLSearchParams(urlDecoded.split('?')[1]);
    }
    return urlParams;
}

function getAssociatedPartnerId() {
    return getCookie('partnerID') || '';
}

function isAccountPage() {
    return window.location.pathname === '/account';
}

function syncCurrentUrlPartnerWithCookie() {
    if (!isAccountPage()) return;
    const partnerId = getAssociatedPartnerId();
    if (!partnerId) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('partner') !== partnerId) {
        url.searchParams.set('partner', partnerId);
        window.history.replaceState({}, '', url.toString());
    }
}

const initPartner = async () => {
    let retryCount = 1;
    const isLoggedIn = !!KROWN.customerId;
    const urlParams = getUrlParams();
    const commSysPartnerIdParam = urlParams.get('partner');
    let partnerDetails = null;

    console.log('Initializing partner info...');
    console.log('Is logged in:', isLoggedIn);
    console.log('commSysPartnerID param:', commSysPartnerIdParam);

    if (isLoggedIn) {
        console.log('Customer ID:', KROWN.customerId);
        partnerDetails = await fetchPartnerInfo(
            KROWN.settings.partner.get_partner_by_customer_id_url,
            "cartCustomerID",
            KROWN.customerId,
            retryCount
        );
        if (!partnerDetails && window.sessionStorage.getItem('customerRegistrationSession') === 'true') {
            console.log('Fetching partner info from localStorage due to customer registration session');
            partnerDetails = getPartnerDetailsFromLocalStorage();
        }
    } else if (commSysPartnerIdParam) {
        let lastCommSysPartnerID = sessionStorage.getItem('lastPartner');
        console.log('Last commSysPartnerID from sessionStorage:', lastCommSysPartnerID);
        if (lastCommSysPartnerID && commSysPartnerIdParam !== lastCommSysPartnerID) {
            console.log('Removing outdated partner info from localStorage');
            localStorage.removeItem("partnerInfo");
        }
        partnerDetails = await fetchPartnerInfo(
            KROWN.settings.partner.get_partner_by_partner_id_url,
            "commSysPartnerID",
            commSysPartnerIdParam,
            retryCount
        );
    } else {
        console.log('Fetching partner info from localStorage');
        partnerDetails = getPartnerDetailsFromLocalStorage();
    }
    if (partnerDetails) {
        console.log('Adding partner block with details for partner:', partnerDetails);
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () => {
                addPartnerBlock(partnerDetails);
                syncCurrentUrlPartnerWithCookie();
            });
        } else {
            addPartnerBlock(partnerDetails);
            syncCurrentUrlPartnerWithCookie();
        }
    } else {
        console.log('Failed to fetch partner information at initPartner');
        removePartnerBlock();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        initPartner();
    }, 500); // 500ms delay to ensure header is rendered
    document.querySelector('.customer-logout')?.addEventListener('click', () => {
        console.log('Customer logged out, clearing customer session data');
        // Only clear customer-specific session data
        sessionStorage.removeItem("customerRegistrationSession");
        // Keep partner info in localStorage and partnerID in cookie to maintain partner name in navigation
    });
});